import { useFavoritesContext } from "~/contexts/favorites.context";

export function useFavorites() {
	return useFavoritesContext();
}
